import React from 'react';

export function HtmlEditor({ ...rest }) {
  return <textarea {...rest} />;
}
